import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-component-button-semiround-to-post',
  templateUrl: './component-button-semiround-to-post.component.html',
  styleUrls: ['./component-button-semiround-to-post.component.scss'],
})
export class ComponentButtonSemiroundToPostComponent implements OnInit {

  @Input() text: string;
  @Input() iconName: string;

  constructor() { }

  ngOnInit() {}

}
